import { createFileRoute } from '@tanstack/react-router';

import { Button, ButtonGroup } from '@/common/components/button';
import { Field, FieldGroup, Fieldset, Label } from '@/common/components/fieldset';
import { Heading, Subheading } from '@/common/components/heading';
import { Input } from '@/common/components/input';
import { Text } from '@/common/components/text';

export const Route = createFileRoute(
  '/applications/$application-id/service-location/existing'
)({
  component: ExistingServiceLocationComponent
});

function ExistingServiceLocationComponent() {
  return (
    <div className="p-8">
      <Heading>New Metered Service</Heading>

      <div className="grid lg:grid-cols-2">
        <div className="flex flex-col justify-start">
          <Fieldset className="mt-4">
            <FieldGroup>
              <Field>
                <Label>Meter Number</Label>
                <Input name="meterNumber" />
              </Field>

              <Field>
                <Label>Requested Connect Date</Label>
                <Input type="date" name="requestedConnectDate" />
                <Text>Connections may not be available on weekends or holidays. If your requested connect date is unavailable, we will select the next business day.</Text>
              </Field>
            </FieldGroup>
          </Fieldset>
        </div>

        <div className="flex flex-col justify-start m-6">
          <Subheading>To Find Your Meter Number:</Subheading>
        </div>
      </div>

      <ButtonGroup>
        <Button to="/applications/$application-id/service-location" params={{ 'application-id': '1' }} outline>Back</Button>
        <Button to="/applications/$application-id/service-location/confirm" params={{ 'application-id': '1' }}>Next</Button>
      </ButtonGroup>
    </div>
  );
}
